module.exports = __webpack_public_path__ + "ae98c50d6cac5c685703a5878fb27b9f.MP3";